import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { VoiceShowcase } from './components/VoiceShowcase';
import { Features } from './components/Features';
import { Pricing } from './components/Pricing';
import { StudioSection } from './components/StudioSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0A0A0F] text-white selection:bg-[#00F0FF] selection:text-black" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <VoiceShowcase data-id="element-4" />
        <Features data-id="element-5" />
        <Pricing data-id="element-6" />
        <StudioSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}